import React from 'react';

import BreadcrumbGroup, { BreadcrumbGroupProps } from '@amzn/awsui-components-react-v3/polaris/breadcrumb-group';

import { USER_DISPLAY_STRINGS_RFX as STRINGS } from '../resources/user_display_strings_rfx';

/**
 * Renders breadcrumb that are used in shipments page
 */

type BreadcrumbsProps = {
  items: Array<BreadcrumbGroupProps.Item>;
};

const rootCrumb = {
    text: STRINGS.breadcrumbs.home,
    href: '/'
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <div className="awsui-util-mb-s">
      <BreadcrumbGroup ariaLabel="Breadcrumbs" items={[rootCrumb, ...items]} />
    </div>
  );
};
